// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"2f9104c7","340":"23f9e7b7","505":"99562f0d","745":"fa6e729b","988":"ccb4e2d6"}[chunkId] + ".js";
};